import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

import { AuthGuardService } from '../_services';

//Components...
import { HomeComponent } from './home/home.component';
import { OrderListComponent } from './order-list/order-list.component';
import { ProductListComponent } from './product-list/product-list.component';
import { SubscriptionListComponent } from './subscription-list/subscription-list.component';
import { CustomerListComponent } from './customer-list/customer-list.component';
import { SettingsComponent } from './settings/settings.component';
import { CategoryListComponent } from "./category-list/category-list.component";
import { ProductDetailComponent } from "./product-detail/product-detail.component";

const routes: Routes = [
  {
		path: "",
		redirectTo:"home",
		pathMatch :"full",
		data: {
      layoutName: "layoutOne"
    }
	},
  {
    path: "home",
    component: HomeComponent,
    data: {
      layoutName: "layoutOne"
    },
    canActivate: [AuthGuardService]
  },
  {
    path: "category-list",
    component: CategoryListComponent,
    data: {
      layoutName: "layoutOne"
    },
    canActivate: [AuthGuardService]
  },
  {
    path: "product-list",
    component: ProductListComponent,
    data: {
      layoutName: "layoutOne"
    },
    canActivate: [AuthGuardService]
  },

  {
    path: "order-list",
    component: OrderListComponent,
    data: {
      layoutName: "layoutOne"
    },
    canActivate: [AuthGuardService]
  },

  {
    path: "subscription-list",
    component: SubscriptionListComponent,
    data: {
      layoutName: "layoutOne"
    },
    canActivate: [AuthGuardService]
  },
  {
    path: "customer-list",
    component: CustomerListComponent,
    data: {
      layoutName: "layoutOne"
    },
    canActivate: [AuthGuardService]
  },
  {
    path: "settings",
    component: SettingsComponent,
    data: {
      layoutName: "layoutOne"
    },
    canActivate: [AuthGuardService]
  },
  {
    path: "product/:id",
    component: ProductDetailComponent,
    data: {
      layoutName: "layoutOne"
    },
    canActivate: [AuthGuardService]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CoreRoutingModule { }
